import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    _placeholder: {
      color: 'grey.400',
    },
    _invalid: {
      borderColor: 'red.500',
      _hover: {
        borderColor: 'red.500',
      },
      _focusVisible: {
        borderColor: 'blue.500',
      },
    },
    _disabled: {
      borderColor: 'grey.300',
      bg: 'grey.50',
      color: 'grey.300',
      _hover: {
        borderColor: 'grey.300',
      },
    },
  },
  sizes: {
    default: {
      width: 'full',
      border: '0.1',
      borderRadius: 'sm-md',
      borderColor: 'grey.400',
      bg: 'white',
      py: '3',
      px: '4',
      minH: '18',
    },
  },
  variants: {
    default: {
      _hover: {
        borderColor: 'blue.300',
      },
      _focusVisible: {
        borderColor: 'blue.500',
      },
    },
    success: {
      borderColor: 'green.500',
      _hover: {
        borderColor: 'green.500',
      },
      _focusVisible: {
        borderColor: 'blue.500',
      },
    },
    warning: {
      borderColor: 'orange.500',
      _hover: {
        borderColor: 'orange.500',
      },
      _focusVisible: {
        borderColor: 'blue.500',
      },
    },
    error: {
      borderColor: 'red.500',
      _hover: {
        borderColor: 'red.500',
      },
      _focusVisible: {
        borderColor: 'blue.500',
      },
    },
  },
  defaultProps: {
    variant: 'default',
    size: 'default',
  },
};
